import {
  useGetOrgFeaturesQuery,
  useGetFeatureUsageQuery,
} from 'src/services/billing/billing.service';

export const useUsageState = () => {
  const { currentData: orgFeatures } = useGetOrgFeaturesQuery();
  const { currentData: featureUsage } = useGetFeatureUsageQuery();

  return { orgFeatures, featureUsage };
};

export default useUsageState;
